<div class="presentation-controls">
  <div class="controls-left">
    <button
      [attr.aria-label]="'Previous image' | translate"
      [disabled]="currentIndex === 0"
      (click)="previous.emit()"
      class="control-button"
    >
      <fa-icon icon="chevron-left"></fa-icon>
    </button>

    <button
      [attr.aria-label]="isPaused ? ('Play' | translate) : ('Pause' | translate)"
      (click)="playPause.emit()"
      class="control-button play-pause"
    >
      <fa-icon [icon]="isPaused ? 'play' : 'pause'"></fa-icon>
    </button>

    <button [attr.aria-label]="'Next image' | translate" (click)="next.emit()" class="control-button">
      <fa-icon icon="chevron-right"></fa-icon>
    </button>
  </div>

  <div class="controls-right">
    <button [attr.aria-label]="'Settings' | translate" (click)="settings.emit()" class="control-button">
      <fa-icon icon="cog"></fa-icon>
    </button>

    <button [attr.aria-label]="'Exit presentation' | translate" (click)="exit.emit()" class="control-button exit">
      <fa-icon icon="times"></fa-icon>
    </button>
  </div>
</div>
